import { Flex, Typography, theme } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { CardComponent } from "../../../../components/Card/CardComponent.tsx"
import Icon from "../../../../Icon/index.tsx"
import { STORY_PILLARS } from "../../content/product-story.ts"

const { Text } = Typography

export const PlatformPillarsGrid = () => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {STORY_PILLARS.map((pillar) => (
        <CardComponent key={pillar.id} className="h-full">
          <Flex vertical gap={8}>
            <Flex
              align="center"
              justify="center"
              className="size-9 rounded-full"
              style={{ background: token.colorPrimaryBg, color: token.colorPrimary }}
            >
              <Icon type={pillar.icon} />
            </Flex>
            <Text strong>{t(pillar.titleKey)}</Text>
            <Text type="secondary" className="text-xs font-mono">
              {t(pillar.flowKey)}
            </Text>
            <Text type="secondary" className="text-sm">
              {t(pillar.descriptionKey)}
            </Text>
          </Flex>
        </CardComponent>
      ))}
    </div>
  )
}
